module.exports = __webpack_public_path__ + "media/images/mobile/hamburger-22abdaa3ffa8aececc3872dd998d079d.svg";